var render = function render(_c,_vm){return _c('div',{staticClass:"col"},[_c('el-tag',{attrs:{"type":"success"}},[_vm._v(" "+_vm._s(_vm.props.row.PaymentDay)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }